// Dependencies
const { MessageBox } = require('element-ui');

const humanize = (str) => str.replace(/([A-Z])/g, ' $1')
  .replace(/^[\s_]+|[\s_]+$/g, '')
  .replace(/[_\s]+/g, ' ')
  .replace(/^[a-z]/, (m) => m.toUpperCase());
/**
 * Manejador de alertas para el usuario.
 * Muestra al usuario una alerta indicando el estado de la aplicación.
 * @param {*} error Objeto de error
 * @returns {Promise}
 */
module.exports = (error) => {
  let msg = 'El sitio no respondió correctamente a la solicitud';
  let messages;
  console.log(error);
  if (error.response?.data?.errors) {
    const { message, errors } = error.response.data;
    messages = errors
      .reduce((acum, curr) => `${acum}<p><b>${humanize(curr.target)}:</b> ${curr.details
        .map((e, idx) => {
          // eslint-disable-next-line no-param-reassign
          e = e.replace('.', '');
          if (idx > 0) {
            // eslint-disable-next-line no-param-reassign
            e = e.toLowerCase();
          }
          return e;
        }).join(', ')}.</p>`, '');
    return MessageBox.alert(messages, message || 'Alerta', {
      dangerouslyUseHTMLString: true,
    });
  }
  if (error && error.response) {
    const { data } = error.response;
    if (data.alerta) {
      msg = data.alerta;
    }
  }
  return MessageBox.alert(msg, 'Alerta');
};
